































































import { Component, Prop, Mixins } from "vue-property-decorator";

/**
 * Utils
 */
import classes from "@/config/wow/classes";
import * as externalLinks from "@/config/external-links";
import * as imageLinks from "@/config/image-links";

import { rank, classNameColorRank } from "@/utils/ranking-helpers";


/**
 * Components
 */
import CharacterSynchronizationStatus from "@/components/_global/CharacterSynchronizationStatus.vue";
import CharacterCell from "@/components/_global/CharacterCell.vue";
import CharacterSpecCell from "@/components/_global/CharacterSpecCell.vue";

/**
 * Mixins
 */
import mixinNow from "@/mixins/now-mixin";


/**
 * Types
 */
import { GetRostersResponse } from "@/api/rosters/get-rosters.response";

/**
 * VueX Modules
 */

/**
 * A roster summary table.
 */
@Component({
	components: {
		CharacterSynchronizationStatus,
		CharacterCell,
		CharacterSpecCell
	}
})
export default class SummaryTable extends Mixins(mixinNow) {
	/// Injections
	classes = classes;
	externalLinks = externalLinks;
	imageLinks = imageLinks;

	classNameColorRank = classNameColorRank;

	/// Properties
	@Prop()
	roster!: GetRostersResponse.Roster;

	/// Attributes
	currentRosterIndex = 0;

	get headers() {
		return [
			{
				text: "",
				value: "sync",
				align: "left",
				sortable: false,
				class: "collapsing"
			},
			{
				text: "",
				value: "wow",
				align: "left",
				sortable: false,
				class: "collapsing"
			},

			{
				text: "",
				value: "wlogs",
				align: "left",
				sortable: false,
				class: "collapsing"
			},
			{
				text: "",
				value: "role",
				align: "left",
				sortable: false,
				class: "collapsing"
			},
			{
				text: this.$t("character.name"),
				value: "name",
				align: "left"
			},
			{
				text: this.$t("character.class"),
				value: "class",
				align: "left"
			},
			{
				text: this.$t("character.ilvl"),
				value: "averageItemLevelEquipped",
				align: "center",
				class: "collapsing"
			},
			// {
			// 	text: this.$t("character.azerite_level"),
			// 	value: "azeriteLevel",
			// 	align: "center",
			// 	class: "collapsing"
			// },
			// {
			// 	text: "",
			// 	value: "rio",
			// 	align: "left",
			// 	sortable: false,
			// 	class: "collapsing"
			// },
			{
				text: this.$t("character.m_plus_score"),
				value: "mythicPlusScore",
				align: "center",
				class: "collapsing"
			},

			{
				text: this.$t("character.highest_weekly_m_plus"),
				value: "highestMythicPlusDoneThisWeek",
				align: "center",
				class: "collapsing"
			},
		];
	}

	get rankFunctionIlvl() {
		return rank(this.displayedRosterCharacters.map(e => e.averageItemLevelEquipped));
	}

	// get rankFunctionAzeriteLevel() {
	// 	return rank(this.displayedRosterCharacters.map(e => e.azeriteLevel));
	// }
	get rankFunctionMPlusScore() {
		return rank(this.displayedRosterCharacters.map(e => e.mythicPlusScore));
	}

	get rankFunctionHighestWeeklyMPlus() {
		return rank(this.displayedRosterCharacters.map(e => e.highestMythicPlusDoneThisWeek));
	}


	/**
	 * The list of characters of the current roster to display.
	 */
	get displayedRosterCharacters() {
		return this.roster.characters
			.sort((a, b) => {
				return ((a.role < b.role) ? 1 : (a.role > b.role) ? -1 : 0)
					|| (b.averageItemLevelEquipped - a.averageItemLevelEquipped)
					|| ((a.name < b.name) ? -1 : (a.name > b.name) ? 1 : 0);
			});
	}

}
